import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Wallet, ArrowRight, Gift } from 'lucide-react';
import { Button } from '../ui/button';
import { API_URL, auth } from './financeApi';
import { RenewalBanner } from './RenewalBanner';

const summary = (s) => {
  const v = s.vehicles.find((x) => x.plan_active);
  if (v) return s.role === 'driver' && v.paid_by_role === 'transport'
    ? `Active on ${v.registration_number} · Paid by your Transport Operator`
    : `Yearly plan active on ${s.vehicles.filter((x) => x.plan_active).length} vehicle(s)`;
  if (s.trial.active) return `Free trial: ${s.trial.days_left} day(s) left`;
  return null;
};

export const FinancePromo = ({ token }) => {
  const navigate = useNavigate();
  const [s, setS] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/finance/status`, auth(token)).then((r) => setS(r.data)).catch(() => setS(null));
  }, [token]);

  if (!s) return null;
  const line = summary(s);
  return (
    <>
    <RenewalBanner status={s} />
    <div className="mb-6 rounded-2xl bg-emerald-950 text-white p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 justify-between" data-testid="finance-promo">
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 rounded-xl bg-amber-400 text-emerald-950 flex items-center justify-center shrink-0"><Wallet className="w-5 h-5" /></span>
        <div>
          <p className="font-heading font-bold">Finance Tracker</p>
          <p className="text-sm text-emerald-100" data-testid="finance-promo-text">
            {line || 'Know where every rand goes. One payment of R199 per vehicle covers your whole year.'}
          </p>
        </div>
      </div>
      <Button onClick={() => navigate('/finance')} className={`rounded-full font-semibold ${line ? 'bg-white text-emerald-950 hover:bg-emerald-50' : 'bg-amber-400 text-emerald-950 hover:bg-amber-300'}`} data-testid="finance-promo-btn">
        {line ? <>Open tracker <ArrowRight className="w-4 h-4 ml-1" /></> : <><Gift className="w-4 h-4 mr-1" /> {s.trial.used ? 'See plans' : 'Try free for 1 month'}</>}
      </Button>
    </div>
    </>
  );
};
